import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { ExpiryReport, ExpiryReportFilter } from '../interfaces/inventory/expiryReport.interface';

const params = (f: ExpiryReportFilter) => ({
  withinDays: f.withinDays, includeExpired: f.includeExpired,
  ...(f.storeId ? { storeId: f.storeId } : {}),
});

/** F6a: lot expiry report (STOCK_VIEW). */
export const ExpiryReportService = {
  report: async (institutionId: string, f: ExpiryReportFilter): Promise<ExpiryReport> =>
    (await axios.get(ENDPOINTS.EXPIRY_REPORT.REPORT(institutionId), { params: params(f) })).data,
  xlsx: async (institutionId: string, f: ExpiryReportFilter): Promise<Blob> =>
    (await axios.get(ENDPOINTS.EXPIRY_REPORT.XLSX(institutionId), { params: params(f), responseType: 'blob' })).data,
};
